var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3478 5.57812C13.2505 6.9285 12.2488 7.96875 11.1564 7.96875C10.064 7.96875 9.06063 6.92883 8.96501 5.57812C8.8654 4.1733 9.84057 3.1875 11.1564 3.1875C12.4722 3.1875 13.4474 4.19887 13.3478 5.57812Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1561 10.0938C8.99227 10.0938 6.91143 11.1685 6.39014 13.2617C6.32108 13.5386 6.49473 13.8125 6.77928 13.8125H15.5333C15.8178 13.8125 15.9905 13.5386 15.9224 13.2617C15.4011 11.135 13.3203 10.0938 11.1561 10.0938Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64027 6.17379C6.56257 7.25223 5.75308 8.10156 4.8805 8.10156C4.00793 8.10156 3.19711 7.25256 3.12074 6.17379C3.04138 5.05186 3.82929 4.25 4.8805 4.25C5.93171 4.25 6.71962 5.07244 6.64027 6.17379Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84017 10.1595C6.24085 9.88488 5.58077 9.7793 4.88118 9.7793C3.15462 9.7793 1.49115 10.6376 1.07445 12.3094C1.01966 12.5305 1.15845 12.7493 1.38556 12.7493H5.11361",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeople);
export default __webpack_public_path__ + "static/media/icon-people.ac487dd71914054d767ae25a95de421a.svg";
export { ForwardRef as ReactComponent };